import { Stack, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { Tag } from "../Inputs/Tags";
import API from "../../services/API";
import { txt } from "../../services/translation";

export function Tags({tag, onChange}){

    const [categories, setCategories] = useState(null)

    useEffect(() => {

        API.get('/tags?type=category')
            .then(r => setCategories(r.data))
            .catch(e => console.log(e))

    }, [])

    const list = categories ? categories.filter(c => c.id !== tag?.id) : [];

    return <>

        {tag && 
            <Tag tag={tag} onDelete={() => onChange(null)}/>
        }

        <Stack direction='row' flexWrap='wrap' sx={{mt: 0.5}}>

            {list.map(c => 
                <CategoryTag 
                    tag={c} 
                    onClick={() => onChange(c)}
                    key={c.id} 
                />
            )}

        </Stack>
    </>
}


function CategoryTag({tag, onClick}){

    const sx = {
        opacity: 0.5,
        cursor: 'pointer',
        m: 0.5,
        fontSize: '0.9em',
        '&:hover': {
            opacity: 1,
            color: tag.color
        }
    }

    return <Box sx={sx} onClick={onClick}>{txt(tag.code + 'Hashtag')}</Box>
}